import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-globe",
  templateUrl: "./med-icon-globe.component.html",
})
export class MedIconGlobeComponent extends SvgMixinComponent {}
